import * as types from "./constants";
import axios from 'axios';
import {REST_SERVER} from "./constants";
import {LOGIN_ERROR_NONE, LOGIN_ERROR_PASSWORD, LOGIN_ERROR_SERVICE} from "./globalReducers";

export function globalLogoutSetShowMessage(showLogin, showLoginError) {
    return {
        type: types.LOGOUT_SHOWMESSAGE,
        showLogin: showLogin,
        showLoginError: showLoginError
    }
}

export function globalShowError(showError) {
    return {
        type: types.SHOW_ERROR,
        showError: showError
    }
}

export function globalShowSpinny(showSpinny) {
    return {
        type: types.SHOW_SPINNY,
        showSpinny: showSpinny
    }
}

export function globalSetSims(sims) {
    return {
        type: types.SET_SIMS,
        sims: sims
    }
}

export function globalSetPacketLogs(packetLogs) {
    return {
        type: types.SET_PACKETLOGS,
        packetLogs: packetLogs
    }
}

export function globalSetCouponHistory(couponHistory) {
    return {
        type: types.SET_COUPONHISTORY,
        couponHistory: couponHistory
    }
}

function setSims(dispatch, json) {
    dispatch(globalLogoutSetShowMessage(false, LOGIN_ERROR_NONE));
    dispatch(globalSetSims(json.sims));
    dispatch(globalSetPacketLogs(null));
    dispatch(globalSetCouponHistory(null));
    dispatch(globalShowError(false));
}

// on app load (one time)
export function globalCheckSession() {
    return function (dispatch) {
        dispatch(globalShowSpinny(true));
        return axios({
            method: 'GET',
            url: `${REST_SERVER}/session`
        })
            .then(r => r.data)
            .then(json => {

                setSims(dispatch, json)
            })
            .catch(err => {
                dispatch(globalLogoutSetShowMessage(
                    true,
                    // don't show password error message first time
                    LOGIN_ERROR_NONE
                ));
            })
            .finally(_ => {
                dispatch(globalShowSpinny(false))
            })
    }
}

export function globalCreateSession(user, password) {
    console.log(`u:${user}`);
    return function (dispatch) {
        dispatch(globalShowSpinny(true));
        return axios({
            method: 'POST',
            url: `${REST_SERVER}/session`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data: `user=${encodeURIComponent(user)}&password=${encodeURIComponent(password)}`
        })
            .then(r => r.data)
            .then(json => {
                setSims(dispatch, json)
            })
            .catch(err => {
                dispatch(globalLogoutSetShowMessage(
                    true,
                    err.response.status === 401 ? LOGIN_ERROR_PASSWORD : LOGIN_ERROR_SERVICE
                ));
            })
            .finally(_ => {
                dispatch(globalShowSpinny(false))
            })
    }
}

export function globalGetPacketLogs(kio) {
    return function (dispatch) {
        dispatch(globalShowSpinny(true));
        return axios({
            method: 'GET',
            url: `${REST_SERVER}/sim/${kio}/packetlogs`
        })
            .then(r => r.data)
            .then(json => {
                dispatch(globalSetPacketLogs(json.packetLogs))
                dispatch(globalSetCouponHistory(null));
                dispatch(globalShowError(false));
            })
            .catch(err => {
                if (err.response.status == 401) dispatch(globalLogoutSetShowMessage(true, LOGIN_ERROR_NONE))
                else dispatch(globalShowError(true));
            })
            .finally(_ => {
                dispatch(globalShowSpinny(false))
            })
    }
}

export function globalGetCoupons(kio) {
    return function (dispatch) {
        dispatch(globalShowSpinny(true));
        return axios({
            method: 'GET',
            url: `${REST_SERVER}/sim/${kio}/couponhistory`
        })
            .then(r => r.data)
            .then(json => {
                dispatch(globalSetPacketLogs(null))
                dispatch(globalSetCouponHistory(json.couponHistory));
                dispatch(globalShowError(false));
            })
            .catch(err => {
                if (err.response.status == 401) dispatch(globalLogoutSetShowMessage(true, LOGIN_ERROR_NONE))
                else dispatch(globalShowError(true));
            })
            .finally(_ => {
                dispatch(globalShowSpinny(false))
            })
    }
}
